import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../App/Hooks/reduxHooks'
import { updateKnowledgeList } from '../Store/Actions'
import { PersonKnowledge } from '../util/PersonKnowledge'

import {
  CheckboxInput,
  TableHeaderData,
  TableRowHead,
  TableRowHeadWrapper,
} from './style'

const tableHeadData = [
  { title: 'Online bookable', value: 'online_bookable' },
  { title: 'Activity', value: 'activity' },
  { title: 'Custom duration', value: 'custom_duration' },
  { title: 'Standard duration', value: 'standard_duration' },
]

type Props = {
  windowWidth: number
  knowledgeData: PersonKnowledge[]
}
export const KnowledgeTableHead: React.FC<Props> = ({
  windowWidth,
  knowledgeData,
}) => {
  const [isSelectAll, setIsSelectAll] = useState<boolean>(false)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const onSelectAllChange = () => {
    setIsSelectAll(!isSelectAll)
    const updatedObject = knowledgeData.map(knowledge => ({
      ...knowledge,
      isActive: !isSelectAll,
    }))
    dispatch(updateKnowledgeList(updatedObject))
  }

  return (
    <TableRowHead>
      {tableHeadData.map(data => (
        <TableHeaderData width={windowWidth} key={data.value}>
          <TableRowHeadWrapper>
            {t(`${data.title}`)}
            {data.value === 'online_bookable' && (
              <CheckboxInput
                type="checkbox"
                checked={isSelectAll}
                width={windowWidth}
                onChange={onSelectAllChange}
              />
            )}
          </TableRowHeadWrapper>
        </TableHeaderData>
      ))}
    </TableRowHead>
  )
}
